/**
 * Display label for a user record coming back from the API.
 * Falls back to username (and then the id) so members without a first/last
 * name on file don't render as an empty row in pickers.
 */
export function userDisplayName(user) {
  if (!user) {
    return '';
  }
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return fullName || user.username || `User #${user.id}`;
}

export default userDisplayName;
